import {
  faArrowTrendUp,
  faArrowTrendDown,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import { TrendDirection } from "./types";

export type TrendType = "up" | "down" | "stable";

export const trendBadgeColors: Record<TrendType, "success" | "error" | "default"> = {
  up: "success",
  down: "error",
  stable: "default",
};

export const trendLabels: Record<TrendType, string> = {
  up: "Rising",
  down: "Declining",
  stable: "Stable",
};

export const trendIconConfig: Record<TrendType, { color: string; icon: any }> = {
  up: { color: "#52c41a", icon: faArrowTrendUp },
  down: { color: "#ff4d4f", icon: faArrowTrendDown },
  stable: { color: "#8c8c8c", icon: faMinus },
};

export const getTrendBadgeColor = (trend: TrendType): "success" | "error" | "default" => {
  return trendBadgeColors[trend];
};

export const trendDirectionOptions: Array<{ value: TrendDirection; label: string }> = [
  { value: "all", label: "All Trends" },
  { value: "up", label: "Trending Up" },
  { value: "down", label: "Trending Down" },
  { value: "stable", label: "Stable" },
];

export const minGrowthRateOptions: Array<{ value: number; label: string }> = [
  { value: 0, label: "0%" },
  { value: 5, label: "5%" },
  { value: 10, label: "10%" },
  { value: 20, label: "20%" },
  { value: 50, label: "50%" },
];
